import { render } from "./Layout.vue?vue&type=template&id=c5256246&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=c5256246&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c5256246"

export default script